module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "export_button",
    on: {
      "click": function($event) {
        _vm.exportGraph()
      }
    }
  }, [_vm._v("Export Graph")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c87e052c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/InfCaseGraph.vue
// module id = 252
// module chunks = 2